import type { FC, PropsWithChildren } from "react";
import React from "react";
import { Navigate } from "react-router-dom";

import { hasValue } from "@core/foundation/types";

import { isAdminToken } from "@platform/core";

import { router } from "../../../bootstrap/router.ts";
import { authSelectors, useAuthStore } from "../state/auth.ts";

import { AuthProvider } from "./AuthProvider.tsx";

export const AuthGuard: FC<PropsWithChildren> = ({ children }) => {
  const authToken = useAuthStore(authSelectors.authToken);

  if (hasValue(authToken) && isAdminToken(authToken)) {
    return <AuthProvider authToken={authToken}>{children}</AuthProvider>;
  }

  return <Navigate replace to={router.getUrl("Signin")} />;
};
